import { PagedCollectionParams } from './paged-collection-params';

/**
 * Class used to handle paginated requests for Users from Accounts API
 */
export class UserPagedCollectionParams extends PagedCollectionParams {
  userStatus: '' | 'All' | 'Invited' | 'Uninvited';
  productId: number | null;
  productLastActiveStatus: '' | 'Active' | 'All' | 'NotActive';
  copilotVersion: string | null = null;
  assignedOnly: boolean | null = null;
  lastActiveDateFilter: string | null = null;
  assetFilter = 0;
  assetFilterReferenceDate: string | null = null;

  constructor(params: {
    offset: number;
    limit: number;
    sortExpression?: string;
    sortDirection?: '' | 'asc' | 'desc';
    query?: string;
    productId?: number;
    userStatus?: '' | 'All' | 'Invited' | 'Uninvited';
    productLastActiveStatus?: '' | 'Active' | 'All' | 'NotActive';
    copilotVersion?: string;
    assignedOnly?: boolean;
    lastActiveDateFilter?: string;
    assetFilterReferenceDate?: string;
  }) {
    super(params);

    this.productLastActiveStatus = params.productLastActiveStatus ?? '';
    this.userStatus = params.userStatus ?? '';
    this.productId = params.productId ?? null;
    this.copilotVersion = params.copilotVersion ?? null;
    this.assignedOnly = params.assignedOnly ?? null;
    this.lastActiveDateFilter = params.lastActiveDateFilter ?? null;
    this.assetFilterReferenceDate = params.assetFilterReferenceDate ?? null;
  }

  private generateUserParams() {
    const params = this.generateParams();

    if (this.userStatus) {
      params.append('userStatus', this.userStatus);
    }

    if (this.productLastActiveStatus) {
      params.append('productLastActiveStatus', this.productLastActiveStatus);
    }

    if (typeof this.productId === 'number') {
      params.append('productId', String(this.productId));
    }

    if (typeof this.copilotVersion === 'string') {
      params.append('copilotVersion', this.copilotVersion);
    }

    if (this.assignedOnly !== null) {
      params.append('assignedOnly', String(this.assignedOnly));
    }

    if (this.lastActiveDateFilter !== null) {
      params.append('lastActiveDateFilter', String(this.lastActiveDateFilter));
    }

    if (this.assetFilterReferenceDate !== null) {
      params.append('assetFilter', String(this.assetFilter));
      params.append(
        'assetFilterReferenceDate',
        String(this.assetFilterReferenceDate)
      );
    }

    return params;
  }

  /**
   * Returns string properly formatted for URL paramters
   */
  override get urlParams() {
    const params = this.generateUserParams();

    return params.toString();
  }
}
